import { errorConstants } from './error.constants';

const initialState = { name: errorConstants.SET_ERROR, isActive: false, isApiError: false, statusCode: null };

function errorReducer(state = initialState, action) {
    switch (action.type) {
        case errorConstants.SET_ERROR:
            return {
                name: action.payload.name,
                isActive: action.payload.isActive,
            };
        case errorConstants.SET_ERROR_API:
            return {
                name: action.payload.name,
                isActive: action.payload.isActive,
                isApiError : action.payload.isApiError,
                statusCode: action.payload.statusCode || null,
            };
        default:
            return state
    }
}

export { errorReducer };